import React from "react";
import {
  Dialog,
  Box,
  Typography,
  IconButton,
  Button,
  Divider
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CommonPopup = ({
  open,
  onClose,
  title,
  width = 900,
  height = 800,
  children,
  footerActions = [] 
}) => {
  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return;
        if (reason === "escapeKeyDown") return;
        onClose();
      }}
      fullWidth={false}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: `${width}px`,
          height: `${height}px`,
          minWidth: `${width}px`,
          minHeight: `${height}px`,
          maxWidth: `${width}px`,
          maxHeight: `${height}px`,
          borderRadius: 2,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column"
        }
      }}
    >
      {/* ===== Header ===== */}
      <Box
        sx={{
          height: 48,
          px: 2.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "linear-gradient(90deg, #eef3fb, #f8fafc)",
          borderBottom: "1px solid #dce3ed"
        }}
      >
        <Typography sx={{ fontWeight: 600, fontSize: 16 }}>
          {title}
        </Typography>

        <IconButton
          onClick={onClose}
          sx={{
            width: 36,
            height: 36,
            "&:hover": { backgroundColor: "#e3e8f0" }
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* ===== Body ===== */}
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflow: "hidden",
          backgroundColor: "#fff"
        }}
      >
        {children}
      </Box>

      {/* ===== Footer ===== */}
      <Divider />
      <Box
        sx={{
          height: 50,
          px: 3,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          backgroundColor: "#f9fafb",
          gap: 1
        }}
      >
        {/* 추가 버튼 영역 */}
        {footerActions.map((action, idx) => (
          <Button
            key={idx}
            variant={action.variant ?? "contained"}
            color={action.color ?? "primary"}
            disabled={action.disabled}
            onClick={action.onClick}
            sx={{
              minWidth: 60,
              height: 25,
              borderRadius: 2,
              paddingLeft: "5px",
              paddingRight: "5px",
              fontWeight: 600,
              color: (action.label==='저장'? "#fff" : "#000"),
              backgroundColor: (action.label==='저장'? "#2e7d32" : "#fff"),
              "&:hover": { backgroundColor: (action.label==='저장'? "#216224ff" : "#b5c7eeff") },
              border: "1px solid #010101",
            }}
          >
            {action.label}
          </Button>
        ))}

        {/* 기본 닫기 버튼 */}        
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            minWidth: 60,
            height: 25,
            paddingLeft: "5px",
            paddingRight: "5px",            
            borderRadius: 2,
            fontWeight: 600,
            backgroundColor: "#4b6cb7",
            "&:hover": { backgroundColor: "#3f5fa3" }
          }}
        >
          닫기
        </Button>
      </Box>
    </Dialog>
  );
};

export default CommonPopup;
